/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-20 17:33:01
 * @LastEditors: K
 * @LastEditTime: 2022-09-27 11:48:49
 */
import { Button, Col, Form, Input, Row, Space } from 'antd';
import styles from './Partner.module.css'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { NavBar } from '../../../compnents/nav/NavBar';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import form from 'antd/lib/form';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../../app/store';
import { EditableList } from '../../../compnents/list/EditableList';
import { herbsListColumns } from '../ReplaceMakeSupplierColumns'
import { ThemeContext } from '../../../theme/ThemeContext';
import { getGoodsList, } from '../ReplaceMakeSupplierSclice';
import { unwrapResult } from '@reduxjs/toolkit';
import { PurchaseModal } from '../../../compnents/importModal/purchaseModal';
import { useLocation } from 'react-router-dom';

export const HerbsDirectoryPage = (): ReactElement => {

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const location: any = useLocation()


  const [params, setParams] = useState<any>({
    size: 10,
    current: 0,
    supplierId: location?.state?.supplierId,    //饮片厂 ID
    tenantId: location?.state?.tenantId     //机构 ID

  })

  const [page, setPage] = useState<any>({
    items: [],
    total: 10
  })

  const [pageLoading, setPageLoading] = useState(false)


  const [isPurchaseModalVisible, setIsPurchaseModalVisible] = useState(false)  // 控制导入弹窗是否显示


  const getPageFn = () => {

    setPageLoading(true)
    dispatch(getGoodsList({ ...params }))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total
        })
      })
      .finally(() => setPageLoading(false))

  }

  const jumpStatus = () => {  // 1.代煎饮片厂  2. 代煎饮片厂-查看合作机钩 3.代煎机构
    switch (location?.state?.status) {
      case 1:
        return '/admin/replaceMakeCenter/replaceMakeSupplier'
      case 2:
        return '/admin/replaceMakeCenter/SupplierPartner'
      case 3:
        return '/admin/replaceMakeCenter/OrganizationPartner'
      default:
        return '/admin/replaceMakeCenter/replaceMakeSupplier'
    }
  }
  const jumpTextStatus = () => {    // 1.代煎饮片厂  2. 代煎饮片厂-查看合作机钩 3.代煎机构
    switch (location?.state?.status) {
      case 1:
        return '饮片厂'
      case 2:
        return '合作机构'
      case 3:
        return '代煎机构'
      default:
        return '饮片厂'
    }
  }


  useEffect(() => {
    form.submit()
  }, [])
  useEffect(() => {
    params.current && getPageFn()
  }, [params])
  return (
    <Col className={styles.wrap}>

      <NavBar
        where={['代煎饮片厂', '药品目录']}
        backtrace={{
          name: jumpTextStatus(),
          path: jumpStatus(),
          state: {
            id: location?.state?.supplierId,
            tenantId: location?.state?.tenantId,
            platformId: location?.state?.status == 3 ? location?.state?.platformId : undefined,
            platformName: location?.state?.status == 3 ? location?.state?.platformName : undefined,
            tenantName: location?.state?.status == 3 ? location?.state?.tenantName : undefined,
            supplierName: location?.state?.status == 2 ? location?.state?.supplierName : undefined,
          },
          routeName: jumpTextStatus(),
        }}

      />

      <Col className={styles.contentWrap}>
        <Form
          form={form}
          autoComplete='off'
          initialValues={{}}

          onFinish={(values) => {
            setParams({
              ...params,
              ...values,
              current: 1,
            })
          }}
        >
          <Row
            justify='space-between'
            align='middle'
            style={{ margin: '10px 0 20px', width: '100%' }}
          >
            <Space>
              <Form.Item name='name' noStyle>
                <Input
                  allowClear
                  placeholder='药品名称'
                  prefix={<SearchOutlined />}
                  style={{ width: '315px' }}
                  onChange={form.submit}
                />
              </Form.Item>

            </Space>
            <Space>
              <Button type='primary' onClick={form.submit}>
                查询
              </Button>
              <Button type='primary' onClick={() => {
                setIsPurchaseModalVisible(true)
              }}>
                更新目录
              </Button>
            </Space>
          </Row>
        </Form>

          <EditableList
            page={{
              items: page.items,
              current: params.current,
              size: params.size,
              total: page.total,
            }}
            loading={pageLoading}
            style={{ color: theme.tc3 }}
            className={styles.table}
          columns={herbsListColumns((params.size || 10) * ((params.current || 1) - 1))}
          onChangePage={(current, size) => {
            setParams({ ...params, current, size })
          }}
        />

        <PurchaseModal

          id={location?.state?.tenantId}
          supplierId={location?.state?.supplierId}
          state={5}
          isPurchaseModalVisible={isPurchaseModalVisible}
          onOk={() => {
            setIsPurchaseModalVisible(false)
            setParams({ ...params, current: 1 })
          }}
          onCancel={() => {
            setIsPurchaseModalVisible(false)
          }}
        />
      </Col>
    </Col>
  );
}

